import unclaimed from '../../../assets/unclaimed.png';

function UnclaimedCard() {
    return <img className="w-full h-full" src={unclaimed} alt="unclaimed-card" />;
}

export default UnclaimedCard;
